import Mark from "./Mark.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import MarkText from "../components/MarkText.ts";
import IMark from "../interfaces/IMark.ts";
import DecodingModel from "../models/DecodingModel.ts";
import RhColors from "@/models/RhColors.ts";

export default class VowelMark extends Mark implements IMark
{

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        if(this.targetTextField)
        {
            const fontSize = Number(this.targetTextField.style.fontSize);
            this.parentTarget = this.targetTextField;
            this.targetTextFieldStyle = this.targetTextField.style;
            this.markWidth = this.markHeight = this.adjustToScale(40)*this.multipleOfDefaultFontSize;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)/20;
            this.markX = this.targetTextField.width/2;
            this.markY = this.targetTextField.height/2 + (this.adjustToScale(115)*this.multipleOfDefaultFontSize);
            if(this.targetTextField.text == "y")
            {
                this.markY = this.targetTextField.height/2 + (this.adjustToScale(150)*this.multipleOfDefaultFontSize);
            }
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const mark = new Graphics();
        mark.moveTo(0, 0);
        mark.lineTo(this.markWidth, this.markHeight);
        mark.moveTo(0, this.markHeight);
        mark.lineTo(this.markWidth, 0);
        mark.stroke({width:this.strokeThickness, color:color, cap:"round"});
        // Work around for cacheAsBitmap. Currently, in v8 cacheAsBitmap is not implemented.
        /*const bmpMark  = new Sprite(DecodingModel.getInstance().app.renderer.generateTexture(mark));
        bmpMark.visible = visible;
        this.addChild(bmpMark);*/
        mark.visible = visible;
        this.addChild(mark);
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}